import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Merchant } from "../models/merchant";
import { GeneralService } from "./general.service";
import { MerchantItems } from "../models/items";
import { MockStoreService } from "./mock-store.service";
import { CookieService } from "ngx-cookie-service";

import {
  CatalogueResponseFromApi,
  Catalogue
} from "../models/catalogueDescriptor";
import { MerchantProfileDetails } from "../models/merchantProfile";
import { AuthResponse } from "../models/auth";

interface ConfirmBankDetails {
  data: { account_name: string; account_number: string; bank_id: number };
  status: boolean;
  message: string;
}

@Injectable({
  providedIn: "root"
})
export class CommunicationService {
  private generalApiUrl: string =
    "https://covidreliefbackend.covidrelief.com.ng/merchantclan/public/index.php/api/";

  private generalApiUrl2: string =
    "https://covidreliefbackend.covidrelief.com.ng/merchantclanbackend/public/index.php/api";
  constructor(
    private http: HttpClient,
    private generalservice: GeneralService,
    private mockservice: MockStoreService,
    private cookieservice: CookieService
  ) {}

  generateHttpOptions(): HttpHeaders {
    let httpOptions: HttpHeaders;
    const token = this.generalservice.getToken();
    // console.log(token);
    httpOptions = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return httpOptions;
  }
  // this function will log the user into the application
  sendLoginDetailsToServer(
    obj: Partial<{
      email: string;
      password: string;
      phone: string;
    }>
  ): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${this.generalApiUrl}login`, obj);
  }

  // this function will register the user
  sendRegisterDetailsToServer(obj: Merchant): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${this.generalApiUrl}register`, obj);
  }

  // this function will verify the user when registration is successfull
  verifyMerchantEmail(token: {
    token: string;
  }): Observable<{ token: string; status: boolean; message: string }> {
    return this.http.post<any>(`${this.generalApiUrl}verify/email`, token);
  }

  // ApiService for item begins here
  // this function send an item to the server
  additems(
    obj: FormData
  ): Observable<{ data: object; message: string; status: boolean }> {
    return this.http.post<{ data: object; message: string; status: boolean }>(
      `${this.generalApiUrl}item`,
      obj,
      {
        headers: this.generateHttpOptions()
      }
    );
  }

  // edits an item
  editItems(
    obj: FormData,
    id: string
  ): Observable<{ message: string; status: boolean }> {
    return this.http.post<{ message: string; status: boolean }>(
      `${this.generalApiUrl}item/${id}/edit`,
      obj,
      {
        headers: this.generateHttpOptions()
      }
    );
  }

  //  fetches all items
  fetchAllItems(
    page_number?: string
  ): Observable<{
    data: Array<MerchantItems>;
    end: boolean;
    prev: any;
    next: any;
    status: boolean;
  }> {
    if (!page_number) {
      page_number = "0";
    }
    return this.http.post<any>(
      `${this.generalApiUrl}items`,
      { page_number },
      { headers: this.generateHttpOptions() }
    );
  }
  //  delete an items
  deleteItem(id: string): Promise<{ message: string; status: boolean }> {
    return this.http
      .delete<any>(`${this.generalApiUrl}item/${id}/delete`, {
        headers: this.generateHttpOptions()
      })
      .toPromise();
  }

  // search All items
  searchItems(search: {
    search: string;
    page_number: string;
  }): Observable<any> {
    return this.http.post(`${this.generalApiUrl}items/search`, search, {
      headers: this.generateHttpOptions()
    });
  }
  //  item apiService ends here

  // catalogue ApiService
  addCatalogue(form: {
    name: string;
    description: string;
    catalogue_item_ids: number[];
  }): Observable<Catalogue> {
    return this.http.post<any>(`${this.generalApiUrl}catalogue`, form, {
      headers: this.generateHttpOptions()
    });
  }

  // this function edits a catalogue.
  editACatalogue(
    form: { name: string; description: string; catalogue_item_ids: number[] },
    id: any
  ): Observable<CatalogueResponseFromApi> {
    return this.http.put<any>(
      `${this.generalApiUrl}catalogue/${id}/edit`,
      form,
      {
        headers: this.generateHttpOptions()
      }
    );
  }

  // this function fetches all catalogue on merchant
  fetchAllCatalogueForMerchant(): Observable<CatalogueResponseFromApi> {
    return this.http.get<any>(`${this.generalApiUrl}catalogues`, {
      headers: this.generateHttpOptions()
    });
  }

  // this function deletes a catalogue
  removeCatalogue(id: string): Promise<{ message: string; status: true }> {
    return this.http
      .delete<any>(`${this.generalApiUrl}catalogue/${id}/delete`)
      .toPromise();
  }
  //  apiService for catalogue

  // COnfirms the account details entered by merchant
  getAccountDetails(obj: {
    account_number: string;
    bank_code: string;
  }): Observable<ConfirmBankDetails> {
    let url = "https://mobile.creditclan.com/webapi/v1/account/resolve";
    let httpHeaders = new HttpHeaders({
      "x-api-key": "z2BhpgFNUA99G8hZiFNv77mHDYcTlecgjybqDACv"
    });
    return this.http.post<any>(url, obj, { headers: httpHeaders });
  }

  // updates the bankInfo done by a merchant
  updateBankInfo(form: {
    bank_id: string;
    account_name: string;
    account_number: string;
    password: string;
  }): Observable<{ message: string; status: boolean }> {
    return this.http.post<any>(`${this.generalApiUrl}profilebank`, form, {
      headers: this.generateHttpOptions()
    });
  }

  // changes the password by a merchant
  updatePassword(form: {
    password: string;
    new_password: string;
  }): Observable<{ message: string; status: boolean }> {
    return this.http.post<any>(`${this.generalApiUrl}profilepassword`, form, {
      headers: this.generateHttpOptions()
    });
  }

  // gets Merchant Profile for prefilling
  getMerchantsProfileData(): Observable<MerchantProfileDetails> {
    return this.http.get<any>(`${this.generalApiUrl}profile`, {
      headers: this.generateHttpOptions()
    });
  }

  // updates the profile Data
  updateProfileData(form: {
    phone: string;
    name: string;
    address: string;
    business_type: number;
  }): Observable<any> {
    return this.http.post<any>(`${this.generalApiUrl}profile`, form, {
      headers: this.generateHttpOptions()
    });
  }

  updateProfilePicture(
    picture: FormData
  ): Observable<{ message: string; status: boolean }> {
    return this.http.post<any>(`${this.generalApiUrl}profilepicture`, picture, {
      headers: this.generateHttpOptions()
    });
  }

  getMerchantRequests() {
    const merchantID = this.generalservice.getMerchantID();
    return this.http.get(
      `${this.generalApiUrl2}/merchant/${merchantID}/requests`
    );
  }
}
